export const onlyDigits = (s: string) => s.replace(/\D/g, '');

export const formatPhone = (value: string) => {
    const digits = onlyDigits(value);
    if (digits.length <= 10) {
        return digits.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
    }
    return digits.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
};

export const formatCpfCnpj = (value: string) => {
    const digits = onlyDigits(value);
    if (digits.length <= 11) {
        // CPF: 000.000.000-00
        return digits
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    // CNPJ: 00.000.000/0000-00
    return digits
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
};

export const stripCountryCode = (phone: string): string => {
    const digits = onlyDigits(phone);
    // If it has 12-13 digits and starts with 55, strip the country code
    return digits.startsWith('55') && digits.length >= 12 ? digits.slice(2) : digits;
};

export const firstName = (name: string) => name.split(' ')[0];
